module.exports = __webpack_public_path__ + "9d8feb97f655b59f05452b39c84a1a34.png";